/**
 * Determines if the current zone selection should be cleared based on building filter.
 *
 * @param {Object|null} zone - The currently selected zone (must have getBuilding method)
 * @param {string|null} filterBuildingId - The building ID from the active filter
 * @returns {boolean} True if the zone selection should be cleared
 */
export function shouldClearZoneSelection(zone, filterBuildingId) {
  if (!zone || !filterBuildingId) {
    return false
  }

  const zoneBuilding = zone.getBuilding()
  return !zoneBuilding?.id || zoneBuilding.id !== filterBuildingId
}
